import { IMaintenanceState } from '@/store/maintenance';
import { IMaintenanceMutations } from './mutations.types';
import { IMaintenanceData } from '@/models';

export const mutations: IMaintenanceMutations = {
  SET_MAINTENANCES(
    state: IMaintenanceState,
    payload: IMaintenanceData[]
  ): void {
    state.maintenances = payload;
  },

  ADD_MAINTENANCE(state: IMaintenanceState, payload: IMaintenanceData): void {
    state.maintenances.push(payload);
  },

  UPDATE_MAINTENANCE(
    state: IMaintenanceState,
    payload: IMaintenanceData
  ): void {
    const index = state.maintenances.findIndex(
      (maintenance: IMaintenanceData) => maintenance.id === payload.id
    );

    state.maintenances.splice(index, 1, payload);
  },

  REMOVE_MAINTENANCE(state: IMaintenanceState, payload: number): void {
    const index = state.maintenances.findIndex(
      (maintenance: IMaintenanceData) => maintenance.id === payload
    );

    state.maintenances.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IMaintenanceState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
